import { isNil } from 'lodash';
import { DEFAULT_ARROW_PROPS } from '../../../../../Shape/config/Shapes';

const getTailHeight = shape => (isNil(shape.get('tailHeight')) ? DEFAULT_ARROW_PROPS.tailHeight : shape.get('tailHeight'));

export default getTailHeight;
